import React, { Fragment, useEffect, useState } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Input, Divider, FormInstance } from "antd";
import { CharacterVerify, IPV4Verify, MaskVerify, basicRequire } from "Utility/RegExp";
import { useAppSelector } from "store/hook";
import { setFields } from "./setFields";

const priority = [
  { label: "Auto", value: "Auto" },
  { label: "LTE", value: "lte" },
  { label: "ETH", value: "eth" },
];

const { Option } = Select;
const BulkConfigFWan = React.memo(
  ({ SubmitConfigonFinish, form }: { SubmitConfigonFinish: (value: any) => void; form: FormInstance<any> }) => {
    // const [firstPri, setFirstPri] = useState("lte");
    // const [secondPri, setSecondPri] = useState("eth");
    const { formData, importSource, selectedModel } = useAppSelector((state) => state.topology);
    const [WanPriority, setWanPriority] = useState("Auto");
    const [WanEthernetType, setWanEthernetType] = useState("");
    const [WanDHCPServer1, setWanDHCPServer1] = useState("");
    const [WanDHCPServer2, setWanDHCPServer2] = useState("");
    const [WanDHCPServer3, setWanDHCPServer3] = useState("");
    const [unAvailableOptions, setUnAvailableOptions] = useState(["Auto"]);

    useEffect(() => {
      //import Wan priority
      if (formData?.wan?.priority?.order?.length === 2) {
        setWanPriority("Auto");
        form.setFieldsValue({ Priority: "Auto" });
      } else if (formData?.wan?.priority?.order?.length) {
        setWanPriority(formData?.wan?.priority?.order?.[0]);
        form.setFieldsValue({ Priority: formData?.wan?.priority?.order?.[0] });
      }

      setWanEthernetType(formData.wan?.ethernet?.type || "dhcp");
      setWanDHCPServer1(formData.wan?.ethernet?.dhcp?.dns?.ipv4?.[0].type);
      setWanDHCPServer2(formData.wan?.ethernet?.dhcp?.dns?.ipv4?.[1].type);
      setWanDHCPServer3(formData.wan?.ethernet?.dhcp?.dns?.ipv4?.[2].type);

      //折疊的form再打開時會重新setField到舊的資料, 避免Import後 NewConfig又看到舊資料
      if (importSource === "NewConfig") {
        return;
      }
      setFields(formData?.wan, form);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    return (
      <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="space-around">
            {selectedModel !== "M301-GW-A" && (
              <Col xs={24} sm={24} md={24} lg={10}>
                <h2>Priority</h2>
                <Divider className={styles.divider} />
                <Form.Item
                  label="Priority"
                  name="Priority"
                  rules={[basicRequire]}
                  initialValue={"Auto"}
                  tooltip={"Specify the connection order."}
                >
                  <Select
                    placeholder={"Auto/LTE/ETH..."}
                    onChange={(value: string) => {
                      setWanPriority(value);
                    }}
                  >
                    {priority.map(({ value, label }) => (
                      <Option key={value} value={value}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {WanPriority === "Auto" && (
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Form.Item name="WAN_priority_1" label="1st" rules={[basicRequire]}>
                        <Select
                          placeholder={"Priority"}
                          onChange={(value: string) => {
                            setUnAvailableOptions(["Auto", value]);
                            form.resetFields(["WAN_priority_2", "WAN_priority_3"]);
                          }}
                        >
                          {priority
                            .filter(({ value }) => value !== "Auto")
                            .map(({ label, value }) => (
                              <Option key={value} value={value}>
                                {label}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                      <Form.Item name="WAN_priority_2" label="2nd" rules={[basicRequire]}>
                        <Select
                          placeholder={"Priority"}
                          onChange={(value: string) => {
                            setUnAvailableOptions((prev) => [...prev, value]);
                            form.resetFields(["WAN_priority_3"]);
                          }}
                        >
                          {priority
                            .filter(({ value }) => value !== "Auto")
                            .map(({ label, value }) => (
                              <Option disabled={unAvailableOptions.includes(value)} key={value} value={value}>
                                {label}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                {WanPriority === "lte" && (
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Form.Item
                        name="WAN_lte_mode"
                        label="LTE Mode"
                        rules={[basicRequire]}
                        tooltip={
                          <Fragment>
                            <p>Bridge: APN1 act as bridge for internet access.</p>
                            <p>Router: APN1 act as router for internet access.</p>
                          </Fragment>
                        }
                      >
                        <Select placeholder={"Bridge/Router"}>
                          <Option key={0} value={"bridge"}>
                            Bridge
                          </Option>
                          <Option key={1} value={"router"}>
                            Router
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Col>
            )}

            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>Ethernet</h2>
              <Divider className={styles.divider} />
              <Form.Item
                name="WAN_ethernet_type"
                label="Ethernet Type"
                rules={[basicRequire]}
                initialValue={"dhcp"}
                tooltip={
                  <Fragment>
                    <p>DHCP Client: DHCP server-assigned IP address, netmask, gateway, and DNS.</p>
                    <p>
                      PPPoE Client: Your ISP will provide you with a username and password. This option is typically
                      used for DSL services.
                    </p>
                    <p>Static IPv4: User-defined IP address, netmask, and gateway address.</p>
                  </Fragment>
                }
              >
                <Select
                  onChange={(value: string) => {
                    setWanEthernetType(value);
                  }}
                  placeholder={"DHCP/PPPoE/Static"}
                >
                  <Option key={1} value={"dhcp"}>
                    DHCP Client
                  </Option>
                  <Option key={2} value={"pppoe"}>
                    PPPoE Client
                  </Option>
                  <Option key={3} value={"static"}>
                    Static IPv4
                  </Option>
                </Select>
              </Form.Item>

              {WanEthernetType === "dhcp" && (
                <Fragment>
                  <h3>DNS Server Configuration</h3>

                  <Form.Item
                    name="WAN_ipv4_type_1"
                    label="IPv4 DNS Server #1"
                    rules={[basicRequire]}
                    // placeholder="DNS Server"
                    initialValue={"ISP"}
                  >
                    <Select
                      onChange={(value: string) => {
                        setWanDHCPServer1(value);
                      }}
                    >
                      <Option key={1} value={"ISP"}>
                        ISP
                      </Option>
                      <Option key={2} value={"manual"}>
                        Manual
                      </Option>
                      <Option key={3} value={"none"}>
                        None
                      </Option>
                    </Select>
                  </Form.Item>
                  {WanDHCPServer1 === "manual" && (
                    <Form.Item
                      name="WAN_ipv4_address_1"
                      label="Address #1"
                      rules={[basicRequire, CharacterVerify]}
                      initialValue={"192.0.0.0"}
                    >
                      <Input placeholder="Input adress" disabled={WanDHCPServer1 !== "manual"} />
                    </Form.Item>
                    // </Col>
                  )}
                  <Form.Item
                    name="WAN_ipv4_type_2"
                    label="IPv4 DNS Server #2"
                    rules={[basicRequire, CharacterVerify]}
                    // placeholder={"DNS Server"}
                    initialValue={"ISP"}
                  >
                    <Select
                      onChange={(value: string) => {
                        setWanDHCPServer2(value);
                      }}
                    >
                      <Option key={1} value={"ISP"}>
                        ISP
                      </Option>
                      <Option key={2} value={"manual"}>
                        Manual
                      </Option>
                      <Option key={3} value={"none"}>
                        None
                      </Option>
                    </Select>
                  </Form.Item>
                  {WanDHCPServer2 === "manual" && (
                    <Form.Item
                      name="WAN_ipv4_address_2"
                      label="Address #2"
                      rules={[basicRequire, CharacterVerify]}
                      initialValue={"192.0.0.0"}
                    >
                      <Input placeholder="Input adress" disabled={WanDHCPServer2 !== "manual"} />
                    </Form.Item>
                    // </Col>
                  )}

                  <Form.Item
                    name="WAN_ipv4_type_3"
                    label="IPv4 DNS Server #3"
                    rules={[basicRequire]}
                    // placeholder={"DNS Server"}
                    initialValue={"ISP"}
                  >
                    <Select
                      onChange={(value: string) => {
                        setWanDHCPServer3(value);
                      }}
                    >
                      <Option key={1} value={"ISP"}>
                        ISP
                      </Option>
                      <Option key={2} value={"manual"}>
                        Manual
                      </Option>
                      <Option key={3} value={"none"}>
                        None
                      </Option>
                    </Select>
                  </Form.Item>
                  {WanDHCPServer3 === "manual" && (
                    // <Col xs={24} sm={24} md={24} lg={7}>
                    <Form.Item
                      name="WAN_ipv4_address_3"
                      label="Address #3"
                      rules={[basicRequire, CharacterVerify]}
                      initialValue={"192.0.0.0"}
                    >
                      <Input placeholder="Input adress" disabled={WanDHCPServer3 !== "manual"} />
                    </Form.Item>
                  )}
                  {/* </Row> */}
                </Fragment>
              )}

              {WanEthernetType === "pppoe" && (
                <Fragment>
                  <h3>PPPoE Client Configuration</h3>
                  <Form.Item name="WAN_username" label="User Name" rules={[basicRequire, CharacterVerify]}>
                    <Input placeholder="User Name" maxLength={30} />
                  </Form.Item>
                  <Form.Item name="WAN_password" label="Password" rules={[CharacterVerify]}>
                    <Input placeholder="Password" maxLength={30} />
                  </Form.Item>
                  {/* <Form.Item name="WAN_service_name" label="Service Name" rules={[basicRequire, CharacterVerify]}>
                    <Input placeholder="Service Name" maxLength={30} />
                  </Form.Item> */}
                </Fragment>
              )}

              {WanEthernetType === "static" && (
                <Fragment>
                  <h3>Static IPv4 Configuration</h3>
                  <Form.Item name="WAN_static_ipv4_address" label="IP Address" rules={[basicRequire, IPV4Verify]}>
                    <Input placeholder="192.0.0.0" maxLength={30} />
                  </Form.Item>
                  <Form.Item name="WAN_static_netmask" label="IP Mask" rules={[basicRequire, MaskVerify]}>
                    <Input placeholder="255.255.255.0" maxLength={30} />
                  </Form.Item>
                  <Form.Item name="WAN_static_gateway" label="Gateway" rules={[basicRequire, IPV4Verify]}>
                    <Input placeholder="192.0.0.0" maxLength={30} />
                  </Form.Item>
                  <h3>DNS Server Configuration</h3>
                  <Form.Item
                    name="WAN_static_ipv4_dns_address1"
                    label="IPv4 DNS Server #1"
                    rules={[basicRequire, CharacterVerify]}
                  >
                    <Input placeholder="DNS Address" maxLength={30} />
                  </Form.Item>
                  <Form.Item name="WAN_static_ipv4_dns_address2" label="IPv4 DNS Server #2" rules={[CharacterVerify]}>
                    <Input placeholder="DNS Address" maxLength={30} />
                  </Form.Item>
                  <Form.Item name="WAN_static_ipv4_dns_address3" label="IPv4 DNS Server #3" rules={[CharacterVerify]}>
                    <Input placeholder="DNS Address" maxLength={30} />
                  </Form.Item>
                </Fragment>
              )}
            </Col>
            {selectedModel === "M301-GW-A" && <Col xs={24} sm={24} md={24} lg={10}></Col>}
          </Row>
        </div>
      </Form>
    );
  }
);
export default BulkConfigFWan;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const assemble = (values: any) => {
  //Ethernet
  let ethernetObj: any = { type: values.WAN_ethernet_type };

  if (values.WAN_ethernet_type === "dhcp") {
    let dhcpObj: any = { dns: {} };
    let ipv4Array = [
      {
        type: values.WAN_ipv4_type_1,
        address: values.WAN_ipv4_address_1 || "8.8.8.8",
      },
      {
        type: values.WAN_ipv4_type_2,
        address: values.WAN_ipv4_address_2 || "8.8.8.8",
      },
      {
        type: values.WAN_ipv4_type_3,
        address: values.WAN_ipv4_address_3 || "8.8.8.8",
      },
    ];

    dhcpObj.dns.ipv4 = ipv4Array;
    ethernetObj.dhcp = dhcpObj;
  } else if (ethernetObj.type === "pppoe") {
    let pppoeObj: any = {};
    pppoeObj.username = values.WAN_username;
    if (values.WAN_password) {
      pppoeObj.password = values.WAN_password;
    }
    pppoeObj.service_name = values.WAN_service_name;
    ethernetObj.pppoe = pppoeObj;
  } else if (ethernetObj.type === "static") {
    let ipv4: any = {
      address: values.WAN_static_ipv4_address,
      netmask: values.WAN_static_netmask,
      gateway: values.WAN_static_gateway,
    };

    let DNSArray = [
      { address: values.WAN_static_ipv4_dns_address1 || "" },
      { address: values.WAN_static_ipv4_dns_address2 || "" },
      { address: values.WAN_static_ipv4_dns_address3 || "" },
    ];
    ipv4.dns = DNSArray;
    ethernetObj.static = {};
    ethernetObj.static.ipv4 = ipv4;
  }

  //Order

  let priorityObj: any = {};
  let OrderArray = [];
  if (values.Priority === "Auto") {
    OrderArray.push(values.WAN_priority_1, values.WAN_priority_2);
  } else if (values.Priority === "lte") {
    OrderArray.push(values.Priority);
    priorityObj.lte = { mode: values.WAN_lte_mode };
  } else {
    OrderArray.push(values.Priority);
  }
  priorityObj.order = OrderArray;

  const wanObj = { priority: priorityObj, ethernet: ethernetObj };

  return wanObj;
};
